import React from "react";

export class DropDownAction extends React.Component {
  state = {
    isOpen: false,
    currentItem: "",
  };

  container = React.createRef();
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.container.current &&
      !this.container.current.contains(event.target)
    ) {
      this.setState({ isOpen: false });
    }
  };

  toggleOpen = () => this.setState({ isOpen: !this.state.isOpen });

  render() {
    const { title, items, drop, customStyle, ulStyle, ...rest } = this.props;
    const menuClass = `dropdown-menu${this.state.isOpen ? " show" : ""}`;
    return (
      <div
        className={drop}
        onClick={this.toggleOpen}
        {...rest}
        ref={this.container}
      >
        <button
          className="btn"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          style={customStyle}
        >
          {title}
        </button>
        <ul
          className={menuClass}
          aria-labelledby="dropdownMenuButton"
          style={ulStyle}
        >
          {items.length &&
            items.map((item, index, array) => (
              <li
                key={index}
                className="dropdown-item"
                style={
                  index + 1 === array.length
                    ? { padding: "0px", margin: "0", height: "100%" }
                    : { padding: "0px", margin: "0", height: "100%" }
                }
              >
                {item}
              </li>
            ))}
        </ul>
      </div>
    );
  }
}

export default DropDownAction;
